import React from 'react'

import { Stack, XStack } from '@zet/design-system'
import { B14, R12, S10 } from '@zet/integration-flow/components/typography'
import { Image } from 'expo-image'

const ProductInEligible = ({ product, otherProduct }) => {
  const gradientProps = {
    start: { x: 0, y: 0 },
    end: { x: 1, y: 1 },
    locations: [0, 1],
  }
  return (
    <Stack className="bg-[#FFF1F0] mx-3 p-3 rounded-2xl  mb-4">
      <S10 className="bg-[#FFCFCB] py-[2px] px-1 rounded-sm self-start text-black">
        {'Not eligible at the moment'}
      </S10>
      <XStack className="mt-3 justify-between items-center mb-3">
        <Stack>
          <R12 className="mb-1">{product?.groupName}</R12>
          <B14 className="text-black">{product?.name}</B14>
        </Stack>
        <Image
          source={{ uri: product?.imageUrl }}
          contentFit="contain"
          className="w-16 h-11 rounded-sm"
        />
      </XStack>
      <R12 className="leading-4">
        {
          'This card doesn’t match your eligibility right now. Explore similar cards that may work for you.'
        }
      </R12>
    </Stack>
    // <>
    //   <Stack className="items-center">
    //     <Stack className="my-3">
    //       <CategoryNotEligibleSmallSvg />
    //     </Stack>
    //     <Stack className="bg-error-10  h-24 w-[90%] items-center justify-between rounded-2xl py-3">
    //       <SH2 className="text-error-150 ">{product?.name}</SH2>
    //       <Stack className="bg-error-20 mt-1 rounded-3xl px-4 py-1">
    //         <SH4 className="text-[#490A0A]">Not Eligible</SH4>
    //       </Stack>
    //     </Stack>
    //     <Stack className="w-[98%] items-center">
    //       <M16 className="py-3">We are Sorry!</M16>
    //       <B14 className="mx-2 text-center text-[#1C1D1F]">
    //         Your profile does not meet the bank's eligibility criteria. Don’t
    //         worry, we have other great options
    //       </B14>
    //     </Stack>
    //   </Stack>

    //   {otherProduct ? (
    //     <XStack className="mb-3 mt-2 items-center justify-between bg-white py-2">
    //       <LinearGradientStyled
    //         {...gradientProps}
    //         colors={['#FFFFFF', '#FFC15E']}
    //         style={styles.gradientWidth}
    //       />
    //       <SH2 numberOfLines={1} className="mx-1 text-[#9B6817]">
    //         You are eligible for other credit cards
    //       </SH2>
    //       <LinearGradientStyled
    //         {...gradientProps}
    //         colors={['#FFC15E', '#FFFFFF']}
    //         style={styles.gradientWidth}
    //       />
    //     </XStack>
    //   ) : null}
    // </>
  )
}

export default ProductInEligible
